import React from 'react';
import { motion } from 'framer-motion';

const InstructionsScreen = ({ onClose }) => {
  return (
    <motion.div
      className="fixed inset-0 bg-black/80 backdrop-blur-lg flex items-center justify-center z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.5, opacity: 0 }}
        className="bg-gray-900/80 border-2 border-blue-500/50 rounded-2xl p-8 text-left max-w-2xl w-full shadow-2xl shadow-blue-500/20"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <h2 className="text-3xl font-mono font-bold text-blue-300 mb-6 text-glow">How to Play</h2>
        
        <div className="space-y-4 text-gray-300 font-sans">
          <p><strong>🐉 My Dragons (Inventory):</strong> View your collected dragons. They generate coins over time. Higher level dragons generate more coins. Sell dragons you don't need, or expand your inventory space.</p>
          <p><strong>💰 Shop:</strong> Buy basic dragons to start your collection. The price of a dragon increases each time you buy one.</p>
          <p><strong>🧬 Breeding:</strong> Combine two dragons to create new ones!
            <ul className="list-disc list-inside ml-4 mt-2 text-sm">
              <li>Combine two identical dragons of the same level to level them up.</li>
              <li>Combine two different dragons to discover new, rarer species based on hidden recipes.</li>
              <li>Failed combinations may result in penalties!</li>
            </ul>
          </p>
          <p><strong>📖 Tome (Encyclopedia):</strong> See all possible dragons and their breeding recipes. You can spend coins or keys to unlock recipes you haven't discovered yet.</p>
          <p><strong>⚔️ Battle:</strong> Assemble a team of 6 dragons and fight against competitors to earn keys and unlock new challenges.</p>
          <p><strong>📜 Index:</strong> Track your collection progress. See which dragons you've discovered and read about them.</p>
        </div>

        <div className="text-center mt-8">
          <button 
              onClick={onClose}
              className="btn btn-primary px-8 py-3"
          >
              Got it!
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default InstructionsScreen;
